import React from 'react'

import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { Box, DataTable } from '@enechain/ecloud-designsystem'
import { getTextAlignLightTableStyle } from '@enechain/eposition-ui'

import { ResultAvailableDealSimulationForOption2Models } from '~/pages/Simulation/models/SimulationResultModel/ResultAvailableDealSimulationDetailForOption2Models'

type Props = {
  resultDetail: ResultAvailableDealSimulationForOption2Models
}

export const ResultLatestPositionForOption2Table: React.FC<Props> = ({
  resultDetail,
}) => {
  const { t } = useTranslation(['page', 'common', 'domain'])
  const columnHelper =
    createColumnHelper<ResultAvailableDealSimulationForOption2Models>()

  const columns = React.useMemo(
    () => [
      columnHelper.accessor('allLimitAmount', {
        header: t('page:simulation.all_limit_amount'),
        cell: (info) => <Box>{info.getValue()}</Box>,
        enableSorting: false,
        meta: getTextAlignLightTableStyle(),
      }),
      columnHelper.accessor('physicalFuturesLimitAmount', {
        header: t('page:simulation.physical_futures_limit_amount'),
        cell: (info) => <Box>{info.getValue()}</Box>,
        enableSorting: false,
        meta: getTextAlignLightTableStyle(),
      }),
    ],
    [columnHelper, t],
  )

  const data = React.useMemo(
    () => (resultDetail !== undefined ? [resultDetail] : []),
    [resultDetail],
  )

  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <DataTable
      table={table}
      emptyComponent={
        <Box width="100%" textAlign="center">
          {t('common:error.empty_data')}
        </Box>
      }
    />
  )
}
